import {BaselineParametersResults} from './baseline-parameters-results';
import {InfusionParametersResults} from './infusion-parameters-results';

export class MeasureResults {

  constructor(
    public baselineParametersResults: BaselineParametersResults | null,
    public infusionParametersResults: InfusionParametersResults | null,
  ) {
  }

  public clone(): MeasureResults {
    return new MeasureResults(
      this.baselineParametersResults,
      this.infusionParametersResults,
    );
  }

  public copy(other: MeasureResults): this {
    this.baselineParametersResults = other.baselineParametersResults;
    this.infusionParametersResults = other.infusionParametersResults;
    return this;
  }
}
